import { render } from "./UAEBoDownload.vue?vue&type=template&id=7317916b&scoped=true"
import script from "./UAEBoDownload.vue?vue&type=script&lang=js"
export * from "./UAEBoDownload.vue?vue&type=script&lang=js"

import "./UAEBoDownload.vue?vue&type=style&index=0&id=7317916b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7317916b"]])

export default __exports__